const getRoot = state => state.existingAccounts;
export const getExistingAccountsRequested = state => getRoot(state).requested;
export const getExistingAccountsFetched = state => getRoot(state).fetched;
export const getExistingAccountsError = state => getRoot(state).fetchError;
export const getExistingAccounts = state => getRoot(state).accounts;
export const isHubless = state => getExistingAccountsFetched(state) && getExistingAccounts(state).length === 0;
export const getExistingAccountsProducts = state => getRoot(state).accounts.flatMap(account => account.products);
export const getHaveHubsFailedToLoad = state => getRoot(state).hubsFailedToLoad;
export const getExistingAccountsFetching = state => getRoot(state).fetching;